const CRMCategory = `
  id
  description
  updatedAt
`;

export default CRMCategory;
